export default {
    data() {
        return {
            professionArray: [{
                "label": "党的机关、国家机关、群众团体和社会组织、企事业单位负责人",
                "value": "10000",
                "children": [{"label": "中国共产党机关负责人", "value": "10100"}, {
                    "label": "国家机关负责人",
                    "value": "10200"
                }, {
                    "label": "民主党派和工商联负责人",
                    "value": "10300"
                }, {
                    "label": "人民团体和群众团体、社会组织及其他成员组织负责人",
                    "value": "10400"
                }, {"label": "基层群众自治组织负责人", "value": "10500"}, {
                    "label": "企事业单位负责人",
                    "value": "10600"
                }]
            }, {
                "label": "专业技术人员",
                "value": "20000",
                "children": [{"label": "科学研究人员", "value": "20100"}, {
                    "label": "工程技术人员",
                    "value": "20200"
                }, {"label": "农业技术人员", "value": "20300"}, {
                    "label": "飞机和船舶技术人员",
                    "value": "20400"
                }, {"label": "卫生专业技术人员", "value": "20500"}, {
                    "label": "经济和金融专业人员",
                    "value": "20600"
                }, {"label": "法律、社会和宗教专业人员", "value": "20700"}, {
                    "label": "教学人员",
                    "value": "20800"
                }, {"label": "文学艺术、体育专业人员", "value": "20900"}, {
                    "label": "新闻出版、文化专业人员",
                    "value": "21000"
                }, {"label": "其他专业技术人员", "value": "29900"}]
            }, {
                "label": "办事人员和有关人员",
                "value": "30000",
                "children": [{"label": "办事人员", "value": "30100"}, {
                    "label": "安全和消防人员",
                    "value": "30200"
                }, {"label": "其他办事人员和有关人员", "value": "39900"}]
            }, {
                "label": "社会生产服务和生活服务人员",
                "value": "40000",
                "children": [{
                    "label": "批发与零售服务人员",
                    "value": "40100"
                }, {"label": "交通运输、仓储和邮政业服务人员", "value": "40200"}, {
                    "label": "住宿和餐饮服务人员",
                    "value": "40300"
                }, {"label": "信息运输、软件和信息技术服务人员", "value": "40400"}, {
                    "label": "金融服务人员",
                    "value": "40500"
                }, {"label": "房地产服务人员", "value": "40600"}, {
                    "label": "租赁和商务服务人员",
                    "value": "40700"
                }, {"label": "技术辅助服务人员", "value": "40800"}, {
                    "label": "水利、环境和公共设施管理服务人员",
                    "value": "40900"
                }, {"label": "居民服务人员", "value": "41000"}, {
                    "label": "电力、燃气及水供应服务人员",
                    "value": "41100"
                }, {"label": "修理及制作服务人员", "value": "41200"}, {
                    "label": "文化、体育及娱乐服务人员",
                    "value": "41300"
                }, {"label": "健康服务人员", "value": "41400"}, {
                    "label": "其他社会生产和生活服务人员",
                    "value": "49900"
                }]
            }, {
                "label": "农林牧渔业生产及辅助人员",
                "value": "50000",
                "children": [{"label": "农业生产人员", "value": "50100"}, {
                    "label": "林业生产人员",
                    "value": "50200"
                }, {"label": "畜牧业生产人员", "value": "50300"}, {
                    "label": "渔业生产人员",
                    "value": "50400"
                }, {"label": "农林牧渔生产辅助人员", "value": "50500"}, {
                    "label": "其他农林牧渔水利业生产人员",
                    "value": "59900"
                }]
            }, {
                "label": "生产制造及有关人员",
                "value": "60000",
                "children": [{"label": "农副产品加工人员", "value": "60100"}, {
                    "label": "食品、饮料生产加工人员",
                    "value": "60200"
                }, {"label": "烟草及其制品加工人员", "value": "60300"}, {
                    "label": "纺织、针织、印染人员",
                    "value": "60400"
                }, {
                    "label": "纺织品、服装和皮革、毛皮制品加工制作人员",
                    "value": "60500"
                }, {"label": "木材加工、家具与木制品制作人员", "value": "60600"}, {
                    "label": "纸及纸制品生产加工人员",
                    "value": "60700"
                }, {"label": "印刷和记录媒介复制人员", "value": "60800"}, {
                    "label": "文教、工美、体育和娱乐用品制作人员",
                    "value": "60900"
                }, {"label": "石油加工和炼焦、煤化工制作人员", "value": "61000"}, {
                    "label": "化学原料和化学制品制造人员",
                    "value": "61100"
                }, {"label": "医药制造人员", "value": "61200"}, {
                    "label": "化学纤维制造人员",
                    "value": "61300"
                }, {"label": "橡胶和塑料制品制造人员", "value": "61400"}, {
                    "label": "非金属矿物制品制造人员",
                    "value": "61500"
                }, {"label": "采矿人员", "value": "61600"}, {
                    "label": "金属冶炼和压延加工人员",
                    "value": "61700"
                }, {"label": "机械制造基础加工人员", "value": "61800"}, {
                    "label": "金属制品制造人员",
                    "value": "61900"
                }, {"label": "通用设备制造人员", "value": "62000"}, {
                    "label": "专用设备制造人员",
                    "value": "62100"
                }, {"label": "汽车制造人员", "value": "62200"}, {
                    "label": "铁路、船舶、航空设备制造人员",
                    "value": "62300"
                }, {"label": "电气机械和器材制造人员", "value": "62400"}, {
                    "label": "计算机、通信和其他电子设备制造人员",
                    "value": "62500"
                }, {"label": "仪器仪表制造人员", "value": "62600"}, {
                    "label": "废弃资源综合利用人员",
                    "value": "62700"
                }, {"label": "电力、热力、气体、水生产和输配人员", "value": "62800"}, {
                    "label": "建筑施工人员",
                    "value": "62900"
                }, {"label": "运输设备和通用工程机械操作人员及有关人员", "value": "63000"}, {
                    "label": "生产辅助人员",
                    "value": "63100"
                }, {"label": "其他生产制造及有关人员", "value": "69900"}]
            }, {"label": "军人", "value": "70000"}, {
                "label": "不便分类的其他从业人员",
                "value": "80000"
            }, {
                "label": "未从业人员",
                "value": "90000",
                "children": [{"label": "在读学生", "value": "90001"}, {"label": "离退休人员", "value": "90002"}]
            }],
            professionMap: {
                "10000": "党的机关、国家机关、群众团体和社会组织、企事业单位负责人",
                "10100": "中国共产党机关负责人",
                "10200": "国家机关负责人",
                "10300": "民主党派和工商联负责人",
                "10400": "人民团体和群众团体、社会组织及其他成员组织负责人",
                "10500": "基层群众自治组织负责人",
                "10600": "企事业单位负责人",
                "20000": "专业技术人员",
                "20100": "科学研究人员",
                "20200": "工程技术人员",
                "20300": "农业技术人员",
                "20400": "飞机和船舶技术人员",
                "20500": "卫生专业技术人员",
                "20600": "经济和金融专业人员",
                "20700": "法律、社会和宗教专业人员",
                "20800": "教学人员",
                "20900": "文学艺术、体育专业人员",
                "21000": "新闻出版、文化专业人员",
                "29900": "其他专业技术人员",
                "30000": "办事人员和有关人员",
                "30100": "办事人员",
                "30200": "安全和消防人员",
                "39900": "其他办事人员和有关人员",
                "40000": "社会生产服务和生活服务人员",
                "40100": "批发与零售服务人员",
                "40200": "交通运输、仓储和邮政业服务人员",
                "40300": "住宿和餐饮服务人员",
                "40400": "信息运输、软件和信息技术服务人员",
                "40500": "金融服务人员",
                "40600": "房地产服务人员",
                "40700": "租赁和商务服务人员",
                "40800": "技术辅助服务人员",
                "40900": "水利、环境和公共设施管理服务人员",
                "41000": "居民服务人员",
                "41100": "电力、燃气及水供应服务人员",
                "41200": "修理及制作服务人员",
                "41300": "文化、体育及娱乐服务人员",
                "41400": "健康服务人员",
                "49900": "其他社会生产和生活服务人员",
                "50000": "农林牧渔业生产及辅助人员",
                "50100": "农业生产人员",
                "50200": "林业生产人员",
                "50300": "畜牧业生产人员",
                "50400": "渔业生产人员",
                "50500": "农林牧渔生产辅助人员",
                "59900": "其他农林牧渔水利业生产人员",
                "60000": "生产制造及有关人员",
                "60100": "农副产品加工人员",
                "60200": "食品、饮料生产加工人员",
                "60300": "烟草及其制品加工人员",
                "60400": "纺织、针织、印染人员",
                "60500": "纺织品、服装和皮革、毛皮制品加工制作人员",
                "60600": "木材加工、家具与木制品制作人员",
                "60700": "纸及纸制品生产加工人员",
                "60800": "印刷和记录媒介复制人员",
                "60900": "文教、工美、体育和娱乐用品制作人员",
                "61000": "石油加工和炼焦、煤化工制作人员",
                "61100": "化学原料和化学制品制造人员",
                "61200": "医药制造人员",
                "61300": "化学纤维制造人员",
                "61400": "橡胶和塑料制品制造人员",
                "61500": "非金属矿物制品制造人员",
                "61600": "采矿人员",
                "61700": "金属冶炼和压延加工人员",
                "61800": "机械制造基础加工人员",
                "61900": "金属制品制造人员",
                "62000": "通用设备制造人员",
                "62100": "专用设备制造人员",
                "62200": "汽车制造人员",
                "62300": "铁路、船舶、航空设备制造人员",
                "62400": "电气机械和器材制造人员",
                "62500": "计算机、通信和其他电子设备制造人员",
                "62600": "仪器仪表制造人员",
                "62700": "废弃资源综合利用人员",
                "62800": "电力、热力、气体、水生产和输配人员",
                "62900": "建筑施工人员",
                "63000": "运输设备和通用工程机械操作人员及有关人员",
                "63100": "生产辅助人员",
                "69900": "其他生产制造及有关人员",
                "70000": "军人",
                "80000": "不便分类的其他从业人员",
                "90000": "未从业人员",
                "90001": "在读学生",
                "90002": "离退休人员"
            }
        }
    },
    methods: {
        // 行业字典变更时使用此方法重新生成数据
        getProfessionArrayAndMapByDictionary(dictionary) {
            const tempMap = {}
            const array = []
            const map = {}
            dictionary.forEach(item => {
                if (item.parentKey) { // 子节点
                    if (tempMap[item.parentKey]) tempMap[item.parentKey].push({label: item.value, value: item.key})
                    else tempMap[item.parentKey] = [{label: item.value, value: item.key}]
                } else { // 父节点
                    if (!tempMap[item.key]) tempMap[item.key] = []
                    array.push({label: item.value, value: item.key, children: tempMap[item.key]})
                }
                map[item.key] = item.value
            })
            array.forEach(item => item.children.length === 0 && delete item.children)
            return {array, map}
        }
    }
}
